// Copyright 2015-2020 SWIM.AI inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {AnyItem, Item} from "../Item";
import {Record} from "../Record";
import {ItemInterpolator} from "./ItemInterpolator";

export class RecordInterpolator extends ItemInterpolator<Record> {
  /** @hidden */
  readonly interpolators: ReadonlyArray<ItemInterpolator<Item>>;

  constructor(r0: Record, r1: Record) {
    super();
    const interpolatorCount = Math.min(r0.length, r1.length);
    const interpolators = new Array<ItemInterpolator>(interpolatorCount);
    for (let i = 0; i < interpolatorCount; i += 1) {
      interpolators[i] = ItemInterpolator.between(r0.getItem(i), r1.getItem(i));
    }
    this.interpolators = interpolators;
  }

  interpolate(u: number): Record {
    const interpolators = this.interpolators;
    const interpolatorCount = interpolators.length;
    const record = Record.create(interpolatorCount);
    for (let i = 0; i < interpolatorCount; i += 1) {
      record.push(this.interpolators[i].interpolate(u));
    }
    return record;
  }

  deinterpolate(f: AnyItem): number {
    return 0; // not implemented
  }

  equals(that: any): boolean {
    if (this === that) {
      return true;
    } else if (that instanceof RecordInterpolator) {
      const n = this.interpolators.length;
      if (n === that.interpolators.length) {
        for (let i = 0; i < n; i += 1) {
          if (!this.interpolators[i].equals(that.interpolators[i])) {
            return false;
          }
        }
        return true;
      }
    }
    return false;
  }
}
ItemInterpolator.Record = RecordInterpolator;
